export const ContactEndpoint = {
  CREATE: '/default/contact/create',
  EDIT_CONTACT: '/default/contact/edit-contact',
  EDIT_BASE: '/default/contact/edit-base',
  EDIT_AUTHENTICATION: '/default/contact/edit-authentication',
  EDIT_TEAMS_SYSTEMS: '/default/contact/edit-teams-systems',
  DELETE: '/default/contact/delete',
  GET: '/default/contact/get',
  GET_BASE_INFO: '/default/contact/get-base-info',
  GET_SYSTEMS_INFO: '/default/contact/get-systems-info',
  GET_TEAMS_INFO: '/default/contact/get-teams-info',
};
